import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/useterm",

        get({ usageTermId, userId }) {
            const url = this.userUrl({
                path: `/${usageTermId}`,
                userId,
            });

            return Vue.http.get(url);
        },

        getUseTermsOptIn({ userId }) {
            const url = this.userUrl({path: "/", userId});

            return Vue.http.get(url);
        },

        list({ page, userId }) {
            const url = this.userUrl({
                path: `/list/${page}`,
                userId,
            });

            return Vue.http.get(url);
        },

        listToFilter({ page, userId, filter }) {
            const url = this.userUrl({
                path: `/list/to/filter/${page}`,
                userId,
            });

            return Vue.http.get(url, {
                params: {
                    filter,
                },
            });
        },

        create({
            name,
            title,
            content,
            optinText,
            userId,
            optionalOptinAccepting,
        }) {
            const url = this.userUrl({
                path: ``,
                userId,
            });

            return Vue.http.post(url, {
                name,
                title,
                content,
                optinText,
                optionalOptinAccepting,
            });
        },

        edit({
            usageTermId,
            name,
            title,
            content,
            optinText,
            userId,
            optionalOptinAccepting,
        }) {
            const url = this.userUrl({
                path: `/${usageTermId}`,
                userId,
            });

            return Vue.http.put(url, {
                name,
                title,
                content,
                optinText,
                optionalOptinAccepting,
            });
        },

        copy({ usageTermId, userId }) {
            const url = this.userUrl({
                path: `/${usageTermId}/copy`,
                userId,
            });

            return Vue.http.post(url);
        },

        remove({ usageTermId, userId }) {
            const url = this.userUrl({
                path: `/${usageTermId}`,
                userId,
            });

            return Vue.http.delete(url);
        },

        publish({ usageTermId, useWifeed, userId }) {
            const url = this.userUrl({
                path: `/${usageTermId}/${useWifeed}`,
                userId,
            });

            return Vue.http.patch(url);
        },
    },

    base
);
